export default __webpack_public_path__ + "static/0223-5f12d792f5f4e56af88b3fd018579284.png";